export const UserJoinIcon = ({ ...props }) => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6659 24.037C28.101 24.037 33.3377 18.7999 33.3377 12.3652C33.3377 5.93009 28.1007 0.693359 21.6659 0.693359C15.2312 0.693359 9.99414 5.93037 9.99414 12.3652C9.99414 18.8002 15.2312 24.037 21.6659 24.037ZM21.6659 2.91642C26.8751 2.91642 31.114 7.15548 31.114 12.3644C31.114 17.5736 26.8749 21.8125 21.6659 21.8125C16.4568 21.8125 12.2179 17.5734 12.2179 12.3644C12.2179 7.15526 16.457 2.91642 21.6659 2.91642Z"
        fill="#36A0FF"
      />
      <path
        d="M38.248 26.7002C31.8129 26.7002 26.5762 31.9372 26.5762 38.372C26.5762 44.8071 31.8132 50.0438 38.248 50.0438C44.6831 50.0438 49.9198 44.8068 49.9198 38.372C49.917 31.9341 44.6828 26.7002 38.248 26.7002ZM38.248 47.8207C33.0388 47.8207 28.7999 43.5817 28.7999 38.3727C28.7999 33.1635 33.039 28.9247 38.248 28.9247C43.4572 28.9247 47.696 33.1637 47.696 38.3727C47.6932 43.5819 43.4569 47.8207 38.248 47.8207Z"
        fill="#36A0FF"
      />
      <path
        d="M26.0867 46.6748H2.46206V41.9521C2.46206 34.3358 8.65803 28.1398 16.2744 28.1398H27.8629C28.4772 28.1398 28.9748 27.6422 28.9748 27.0279C28.9748 26.4136 28.4772 25.916 27.8629 25.916H16.2744C7.43193 25.916 0.238281 33.1097 0.238281 41.9521V47.7867C0.238281 48.4011 0.735852 48.8986 1.35017 48.8986H26.0871C26.7014 48.8986 27.199 48.4011 27.199 47.7867C27.199 47.1724 26.7011 46.6748 26.0867 46.6748Z"
        fill="#36A0FF"
      />
      <path
        d="M41.8845 37.2599H39.3605V34.7359C39.3605 34.1216 38.8629 33.624 38.2486 33.624C37.6343 33.624 37.1367 34.1216 37.1367 34.7359V37.2599H34.6099C33.9956 37.2599 33.498 37.7575 33.498 38.3718C33.498 38.9861 33.9956 39.4837 34.6099 39.4837H37.1367V42.0077C37.1367 42.622 37.6343 43.1196 38.2486 43.1196C38.8629 43.1196 39.3605 42.622 39.3605 42.0077V39.4837H41.8845C42.4988 39.4837 42.9964 38.9861 42.9964 38.3718C42.9964 37.7575 42.4988 37.2599 41.8845 37.2599Z"
        fill="#36A0FF"
      />
    </svg>
  );
};
